import * as ChatbotFlowService from '../../../../../../services/2talk/chatbot-flow.service';

export const getItemsSelect = async (id, type) => {
  var result = await ChatbotFlowService.getItemsSelect(id, type);

  if (result.success && result?.data?.length > 0) {
    return result?.data;         
  } 

  return [];
};

export const getVariablesAndCustomFields =  async () => {
  var result = await ChatbotFlowService.getVariablesAndCustomFields();

  if (result.success && result?.data?.length > 0) {
    return result?.data;
  }

  return [];
};

// F7 Fase 1 — endpoint unificado (6 categorias: param, variable, customField,
// chat, system, session). Retorna já a lista flat, cada item com { category,
// key, wrap, id?, label }.
export const getPlaceholders = async () => {
  var result = await ChatbotFlowService.getPlaceholders();

  if (result.success && result?.data?.length > 0) {
    return result?.data;
  }

  return [];
};